// E:\Pythonupgrade_again\portal-code\client\src\components\Admin\Helpers\Forms\DateDaysPicker.ts
import * as _ from "lodash";
import moment from "moment";
import { IForm } from "../../Interface/IForm";
import { IFormElementUpdate } from "../../Interface/FormElement/IFormElementUpdate";
import { IFormGroup } from "../../Interface/IFormGroup";
import { IFormElement } from "../../Interface/FormElement/IFormElement";
import { FORM_ELEMENT_TYPES } from "../../Form/ElementTypes";
import { FormElementHelper } from "./Element";
import { DateUtil } from "../../../../UI/Elements/Forms/helper/Utils/Date";

// Date and Days Element Helper
export class EditDateDaysElement{//NOSONAR
    private elementHelper: FormElementHelper;
    private dateUtil: DateUtil;

    constructor(){
        this.elementHelper = new FormElementHelper();
        this.dateUtil = new DateUtil();
    }

    /**
         * Find the parent and child relationship for datepickers
         *
         * @param {IForm[]} forms.
         * @param {IElementUpdate} element.
         * @return {IForm[]} Forms.
         */
        public updateFormsForDatePicker = (forms: IForm[], element: IFormElementUpdate): IForm[] =>{//NOSONAR
            return forms.map((form: IForm) =>{//NOSONAR
                return {
                    ...form,
                    groups: form.groups.map((formGroup: IFormGroup)=>{//NOSONAR
                        return {
                            ...formGroup,
                            elements: formGroup.elements.map((formElement: IFormElement)=>{
                                const FormElement = {
                                    ...formElement,
                                };
            
                                if(_.isEqual(FormElement.type, FORM_ELEMENT_TYPES.DATETIME_INPUT)){
                                  
                                    let errorMessage = FormElement.errorMessage;
                                    if(_.isEqual(FormElement.id, element.formElement.id)){
                                        const ParentElement = this.elementHelper.findFormElement(forms,FormElement);
                                        const ChildElement = this.elementHelper.findDateChildFormElement(forms, FormElement.id);
                                       
                                        if(!_.isNull(ParentElement)){
                                            const ParentValue = (ParentElement?.value || null);
                                            const ElementValue = element.value || null;
                                            
                                            if(!_.isNull(ParentValue) && !_.isNull(ElementValue)){
                                                const StartDate = ParentElement?.value;
                                                const EndDate = element.value;
                                                
                                                if(!this.compareDates(FormElement, StartDate, EndDate)){
                                                    errorMessage =  `${FormElement.id} should be greater than ${ParentElement?.id}.`;
                                                }
                                                else{
                                                    errorMessage = "";
                                                }
                                            }
                                        }
                                        else if(!_.isNull(ChildElement)){
                                            const ParentValue = (element.value || null);
                                            const ElementValue = ChildElement?.value || null;
            
                                            if(!_.isNull(ParentValue) && !_.isNull(ElementValue)){
                                                const StartDate = element.value;
                                                const EndDate = ChildElement?.value;
                                               
                                                if(!this.compareDates(FormElement, StartDate, EndDate)){
                                                    errorMessage =  `${FormElement.id} should be less or equal to ${ChildElement?.id}.`;
                                                }
                                                else{
                                                    errorMessage = "";
                                                }
                                            }
                                        }
                                    }
                                    else if(_.isEqual(element.formElement.parent_compare_element_id, FormElement.id)){
                                        
                                        const ParentValue = (FormElement?.value || null);
                                        const ElementValue = element.value || null;
                                    
                                        if(!_.isNull(ParentValue) && !_.isNull(ElementValue)){
                                            const StartDate = FormElement?.value;
                                            const EndDate = element.value;
                                       
                                            if(this.compareDates(FormElement, StartDate, EndDate)){
                                                errorMessage = "";
                                            }
                                        }
                                        else if(!_.isNull(ParentValue) && _.isNull(ElementValue)){
                                            errorMessage = "";
                                        }
                                    }
                                    else if(_.isEqual(FormElement.parent_compare_element_id,element.formElement.id)){
                                        const ParentValue = (element.value || null);
                                        const ElementValue = FormElement?.value || null;
                                            
                                        if(!_.isNull(ParentValue) && !_.isNull(ElementValue)){
                                            const StartDate = element.value;
                                            const EndDate = FormElement?.value;
                                                
                                            if(this.compareDates(FormElement, StartDate, EndDate)){
                                                errorMessage =  "";
                                            }
                                        }
                                        else if(!_.isNull(ElementValue) && _.isNull(ParentValue)){
                                            errorMessage = "";
                                        }
                                    }

                                    FormElement.errorMessage = errorMessage; 
                                    FormElement.isValid = !_.isEmpty(FormElement?.value) && _.isEqual(errorMessage.length, 0);
                                }
            
                                return FormElement;
                            })
                        };
                    })
                };
             });
        }

        /**
             * Compare the two dates
             *
             * @param {any} start.
             * @param {any} end.
             * @param {IFormElement} formElement.
             * @return {boolean} If the End date is not less than start date.
             */
            compareDates = (formElement: IFormElement, start: any, end: any): any =>{
                const dateFormat = formElement.show_time ? DateUtil.momentDateTimeFormat 
                    : DateUtil.momentDateFormat;
                const StartDate = moment(start, "YYYY-MM-DD h:mm A").format(dateFormat);
                const EndDate = moment(end,"YYYY-MM-DD h:mm A").format(dateFormat);
            
                return this.compareStartAndEndDate(StartDate, EndDate, dateFormat);
            }
        /**
             * Compare the two dates with the given format
             *
             * @param {any} start.
             * @param {any} end.
             * @param {string} dateFormat.
             * @return {boolean} If the End date is not less than start date.
             */
            compareStartAndEndDate = (start: any, end: any, dateFormat: string): any =>{
                const StartDate = moment(start, dateFormat, true).local();
                const EndDate = moment(end, dateFormat, true).local();
            
                const Diff = EndDate.diff(StartDate);
                
                return !_.lte(Diff, 0);
            }   
        
        
}